import React, { useState, useCallback, useEffect } from "react";
import styles from "./SelectCompanyLogin.module.css";
import { useNavigate } from "react-router";
import axios from "axios";
import store from "../../Store/Store";
import { jwtDecode } from "jwt-decode";
import {
  CognitoIdentityProviderClient,
  InitiateAuthCommand,
  RespondToAuthChallengeCommand,
} from "@aws-sdk/client-cognito-identity-provider";
import config from "../../config/config";

export default function SelectCompanyLogin() {
  const [SearchComp, setSearchComp] = useState("");
  const [data, setData] = useState([]);
  const [auth, setAuth] = useState(null);
  const [NoCompany, setNoCompany] = useState(false);
  const [selectCompany, setSelectedCompany] = useState(null);
  const navigate = useNavigate();
  let tokens = localStorage.getItem("authToken");
  let parsedTokens = JSON.parse(tokens);

  useEffect(() => {
    setNoCompany(false);
  }, [selectCompany]);

  useEffect(() => {
    let auth = localStorage.getItem("authToken");
    if (!auth) {
      navigate("/login");
      return;
    }

    let payload = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${config.node_api_endpoint}/cupi/admin/get_cupi_companies`,
      headers: {
        aws_cognito_id_token: parsedTokens.IdToken,
        aws_cognito_access_token: parsedTokens.AccessToken,
        "Content-Type": "application/json",
      },
      data: {},
    };

    axios
      .request(payload)
      .then((res) => {
        setData(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);


  const companyChange = (data) => {
    console.log("data", data);
    setSelectedCompany(data);
  };
  const getUsersAccess = async (compid) => {
    let tokens = localStorage.getItem("authToken");
    let parsedTokens = JSON.parse(tokens);
    let token = parsedTokens.IdToken;
    let getNewTokens = jwtDecode(token);
    console.log("getNewTokens", getNewTokens);
    let ownerAccess = getNewTokens["custom:cupi_owner"];
    ownerAccess=ownerAccess?ownerAccess:[]
    let AdminAccess = getNewTokens["custom:cupi_admin"];
    AdminAccess=AdminAccess?AdminAccess:[]
    console.log("ownerAccess", ownerAccess);
    console.log("AdminAccess", AdminAccess);
    const userOwnerAccess = ownerAccess.includes(compid);
    const userAdminAccess = AdminAccess.includes(compid);
    console.log("userOwnerAccess", userOwnerAccess);
    console.log("userAdminAccess", userAdminAccess);
    if (userOwnerAccess) {
      console.log("===============this user is a OWNER===============");
      store.setIsUserAdmin(true);
      store.setIsUserOwner(true);
    } else if (userAdminAccess) {
      store.setIsUserOwner(false);
      console.log("===============this user is a Admin===============");
      store.setIsUserAdmin(true);
    }
  };
  const processed = async () => {
    if (!selectCompany) {
      return;
    }
    await getUsersAccess(selectCompany.ledger_label);
    console.log("SelectedComp", selectCompany);
    if (selectCompany == null) {
      // alert("Please select a brand to Proceed.");
      setNoCompany(true);
      await new Promise((resolve) => setTimeout(resolve, 2000));
      setNoCompany(false);
      return;
    }
    console.log("SelectedComp", selectCompany);

    store.setCompanyName(selectCompany?.registered_company_name);
    store.setCompId(selectCompany?.ledger_label);
    store.setUserType(selectCompany?.company_flow);
    navigate("/content");
  };

  const verifyTokens = () => {
    let auth = localStorage.getItem("authToken");
    let parsedAuth = JSON.parse(auth);
    console.log("parsedAuth SelecytComp", parsedAuth);

    setAuth(parsedAuth);
    const Expired = isTokenExpired(parsedAuth.IdToken);
    console.log("Expired->", Expired);
    if (Expired) {
      getNewTokens();
    }
  };

  const getNewTokens = async () => {
    console.log("auth inn get AUthTOken", auth);

    if (!auth.RefreshToken) {
      console.log("No refresh token available.");
      return;
    }

    try {
      const client = new CognitoIdentityProviderClient({
        region: "ap-south-1",
      }); // Replace 'your-region' with your AWS region

      const params = {
        ClientId: "77fglk6ill774c4v5toavua4md", // Your Cognito App Client ID
        AuthFlow: "REFRESH_TOKEN_AUTH",
        AuthParameters: {
          REFRESH_TOKEN: auth.RefreshToken,
        },
      };

      const command = new InitiateAuthCommand(params);
      const refreshResponse = await client.send(command);

      if (refreshResponse.AuthenticationResult) {
        console.log("IdToken", refreshResponse.AuthenticationResult.IdToken);
        console.log("Tokens refreshed successfully!");
      } else {
        console.log("Refresh token expired.");
        localStorage.setItem("authToken", JSON.stringify({}));
        navigate("/login");
      }
    } catch (error) {
      navigate("/login");
      console.error("Error refreshing tokens:", error);
    }
  };

  function isTokenExpired(token) {
    const decoded = jwtDecode(token);
    if (decoded && decoded.exp) {
      const currentTime = Math.floor(Date.now() / 1000); // Get current time in seconds
      return decoded.exp < currentTime; // Compare expiration time with current time
    }
    return true;
  }

  // Filter companies based on the search input
  const filteredCompanies = data.filter((company) =>
    company.registered_company_name
      .toLowerCase()
      .includes(SearchComp.toLowerCase())
  );

  return (
    <div className={styles.logincontainer}>
      <div className={styles.card}>
        <div className={styles.welcomeToEscrowStackParent}>
          <img alt="" src="./Final_Cupi.svg" />
        </div>
        <div className={styles.welcomeToEscrowStackParent}>
          <div className={styles.welcomeToEscrow}>
            Please Select the Brand to Continue
          </div>
        </div>
        <div className={styles.innercard}>
          <div className={styles.welcomeSelectBrand}>
            <div className={styles.welcomeselect}>Select Brand</div>
          </div>
          <div className={styles.inputoutlinedParent}>
            <div className={styles.inputoutlined}>
              <img src="./leading-icon.svg" className={styles.search} />
              {/* Filter */}
              <input
                value={SearchComp}
                type="text"
                placeholder="Search Brand"
                onChange={(e) => {
                  setSearchComp(e.target.value);
                }}
                className={styles.input}
              />
            </div>

            <div className={styles.companyList}>
              {filteredCompanies.map((res) => (
                <button
                  key={res?.registered_company_name}
                  className={styles.companyItem}
                  onClick={() => {
                    companyChange(res);
                  }}
                >
                  <img
                    alt=""
                    src={
                      selectCompany?.registered_company_name ===
                      res?.registered_company_name
                        ? "./selected.svg"
                        : "./select.svg"
                    }
                    className={styles.companyimg}
                  />
                  <div>
                    {res?.registered_company_name == "Escrow Stack Pvt Ltd"
                      ? "Wayne Enterprises Pvt Ltd"
                      : res?.registered_company_name}
                  </div>
                </button>
              ))}
              {filteredCompanies.length < 1 && <div>No Brand Found</div>}
            </div>
            {NoCompany && (
              <div className={styles.error}>
                Please select a Brand to proceed.
              </div>
            )}
            <button
              className={styles.button}
              onClick={() => {
                processed();
              }}
            >
              Proceed & Login
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
